import BmlPaymentButton from "../methods/BmlPaymentButton";
import BackButton from "../ui/BackButton";

export default function BmlGatewayStep({
  order_id,
  itemId,
  amount,
  onBack,
}: {
  order_id?: number;
  itemId: number;
  amount: number;
  onBack: () => void;
}) {
  return (
    <div className="space-y-4 animate-slideIn">
      <div className="flex">{amount}</div>
      <BmlPaymentButton order_id={order_id} entityId={itemId} entityType="order" amount={amount} onSuccess={() => {}} />
      <BackButton onClick={onBack} />
    </div>
  );
}